import { Box, Button, Collapse, IconButton, Stack, Typography } from "@mui/material"
import { useSnackbar } from "notistack"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"
import { useReferenceState } from "lib/@hooks/use-reference"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { copyTextToClipboard } from "lib/copy-to-clipboard"

export function OriginalSourcePanel({ onEditSource }) {
    const { category, readOnly } = useBoundContext()
    const [sourceExpandedVariable, setSourceExpanded] = useReferenceState("library-source-expanded", false)
    const { enqueueSnackbar } = useSnackbar()
    const sourceExpanded = sourceExpandedVariable || !(category?.tasks ?? []).length
    const sourceToggleIcon = sourceExpanded ? "eva:chevron-up-fill" : "eva:chevron-down-fill"

    if (!category?.originalText) return null

    return (
        <Box
            sx={{
                mb: 4,
                border: (theme) => `1px solid ${theme.palette.divider}`,
                borderRadius: 1,
                bgcolor: "background.paper",
            }}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 0.5, px: 2 }}>
                <Button
                    variant="text"
                    disabled={!(category?.tasks ?? []).length}
                    color="inherit"
                    onClick={handleToggle}
                    startIcon={<Iconify icon={sourceToggleIcon} />}
                    sx={{
                        textTransform: "none",
                        justifyContent: "flex-start",
                        flexGrow: 1,
                        py: 1,
                        "&:hover": {
                            bgcolor: "transparent",
                            color: "primary.main",
                        },
                    }}
                >
                    <Typography variant="subtitle2">Original Source Text</Typography>
                </Button>
                <Stack direction="row" spacing={1}>
                    <If truthy={sourceExpanded && !readOnly}>
                        <IconButton aria-label="Edit source" size="small" color="primary" onClick={handleEditSource}>
                            <Iconify icon="eva:edit-fill" width={18} height={18} />
                        </IconButton>
                    </If>
                    <IconButton
                        aria-label="Copy source text"
                        size="small"
                        color="primary"
                        onClick={handleCopySourceText}
                    >
                        <Iconify icon="eva:copy-fill" width={18} height={18} />
                    </IconButton>
                </Stack>
            </Stack>
            <Collapse in={sourceExpanded}>
                <Box sx={{ p: 2, borderTop: (theme) => `1px solid ${theme.palette.divider}` }}>
                    <Typography
                        component="pre"
                        variant="caption"
                        sx={{
                            whiteSpace: "pre-wrap",
                            fontFamily: "monospace",
                            bgcolor: "background.neutral",
                            p: 2,
                            borderRadius: 1,
                        }}
                    >
                        {category.originalText}
                    </Typography>
                </Box>
            </Collapse>
        </Box>
    )

    function handleToggle() {
        setSourceExpanded(!sourceExpanded)
    }

    function handleEditSource(e) {
        e.stopPropagation()
        onEditSource(e)
    }

    function handleCopySourceText(e) {
        e.stopPropagation()
        if (category?.originalText) {
            copyTextToClipboard(category.originalText)
            enqueueSnackbar("Copied to clipboard")
        }
    }
}
